// extracted by mini-css-extract-plugin
module.exports = {"imageOverlay":"imageUpload_imageOverlay__2VG3f","image":"imageUpload_image__3CADg","btn":"imageUpload_btn__B_3ZQ"};